// extracted by mini-css-extract-plugin
export default {"sideSocial":"SideSocial_sideSocial__vNxzX","main__social-container":"SideSocial_main__social-container__6I2g2"};